import { render, staticRenderFns } from "./QuestionFooter.vue?vue&type=template&id=fcdf8fca&"
import script from "./QuestionFooter.vue?vue&type=script&lang=js&"
export * from "./QuestionFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports